/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Cloud Drive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ChangeSharedEntryPermissionsBody} from './schemas/change-shared-entry-permissions-body';

import type {ShareEntryBody} from './schemas/share-entry-body';

import type {UnshareEntriesBody} from './schemas/unshare-entries-body';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Share files
 */
export const shareEntry = (
  id: number,
  shareEntryBody: ShareEntryBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/${id}/share`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: shareEntryBody,
    },
    options,
  );
};
/**
 * @summary Unshare files
 */
export const unshareEntries = (
  unshareEntriesBody: UnshareEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/bulk/unshare`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: unshareEntriesBody,
    },
    options,
  );
};
/**
 * @summary Change shared file permissions
 */
export const changeSharedEntryPermissions = (
  id: number,
  changeSharedEntryPermissionsBody: ChangeSharedEntryPermissionsBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/${id}/change-permissions`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: changeSharedEntryPermissionsBody,
    },
    options,
  );
};
export type ShareEntryResult = NonNullable<
  Awaited<ReturnType<typeof shareEntry>>
>;
export type UnshareEntriesResult = NonNullable<
  Awaited<ReturnType<typeof unshareEntries>>
>;
export type ChangeSharedEntryPermissionsResult = NonNullable<
  Awaited<ReturnType<typeof changeSharedEntryPermissions>>
>;
